<template>
  <div class="vz-individual-order-cargo-insurance-transportation">
    <div class="vz-individual-order-cargo-insurance">
      <vz-select
        v-model="insuranceType"
        :items="insuranceTypes"
        :no-empty="true"
        :disabled="disabled"
        always-loud-validation
        with-tooltips
        big
        class="vz-individual-order-cargo-insurance-type"
        label="Страхование"
      />
      <vz-measure-input
        v-if="isCategoryCargoInsurance"
        v-model="insuranceValue"
        :disabled="disabled"
        label="Сумма"
        class="vz-individual-order-cargo-insurance-value"
        placeholder="0"
        big
        measure="руб."
        :has-info-for-b-y="isCurrencyBY"
        with-max-notice
        :mask-integer-limit="9"
        :max-value="99999999"
        :min-value="0"
        @change="onChangeInsuranceValue"
      />
    </div>
    <div v-if="!hideCustomId" class="vz-individual-order-cargo-transportation">
      <div class="text-subtitle color-dark" style="padding-right: 10px">
        Ваш номер перевозки
        <vz-tooltip-info text="Если хотите привязать свой номер перевозки - укажите его в поле ниже"/>
      </div>
      <vz-textarea
        v-model="transportationId"
        :disabled="disabled"
        rows="1"
        placeholder="Номер перевозки"
        max-length="255"
        class="vz-individual-order-cargo-transportation-id"
        autosize
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {SelectItem} from '~/types/types';
import {useOrderStore} from '~/stores/order';
import VzTextarea from '~/components/ui-kit/vz-textarea.vue';
import VzSelect from '~/components/ui-kit/vz-select.vue';
import {phoneCountries} from "~/common/objects";
import VzMeasureInput from "~/components/ui-kit/vz-measure-input.vue";

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  hideCustomId: {
    type: Boolean,
    default: false
  }
})

const orderStore = useOrderStore()

const isCurrencyBYRU = computed(() => {
  return ['RU', 'BY'].includes(orderStore.orderForm?.currency)
})

const isCurrencyBY = computed(() => {
  return ['BY'].includes(orderStore.orderForm?.currency)
})

const measureCurrency = computed(() => {
  return phoneCountries.find((val) => {
    return val.value === orderStore.orderForm?.currency
  })?.currency
})

const insuranceTypes = computed((): SelectItem[] => {
  const noDeclaredValueCostText = orderStore.orderPrice?.insurance?.noDeclaredValue?.price?.total
    ? `(${orderStore.orderPrice?.insurance?.noDeclaredValue?.price?.total || 0} ${orderStore.orderPriceCurrency?.currency})`
    : ''
  return [
    {
      value: 'cargoInsurance',
      title: 'Страхование груза',
      tooltip: 'Страхование производится по тарифам, установленным страховой компанией на дату предъявления груза. ' +
        `Страховой тариф - ${isCurrencyBY.value ? '0,2' : '0,15'}%.`
    },
    {
      value: 'noDeclaredValue',
      title: `Без объявленной стоимости ${noDeclaredValueCostText}`,
      tooltip: 'Страхование без объявленной стоимости.<br/><br/>Применяется ряд фиксированных тарифов, размер которых ' +
        'зависит от весогабаритных характеристик груза (с перечнем тарифов можно ознакомиться ' +
        `<a target="_blank" href="${isCurrencyBY.value ? 'https://vozovoz.by/insurance/' : 'https://vozovoz.ru/insurance/'}">по ссылке</a>)<br/><br/>` +
        'Обязательно для плательщика, являющегося юридическим лицом',
      disabled: !isCurrencyBYRU.value
    },
    {
      value: 'without',
      title: 'Без страхования'
    }
  ]
})

const isCategoryCargoInsurance = computed(() => {
  return orderStore.orderForm.cargo.insurance.type === 'cargoInsurance'
})

const insuranceType = computed({
  get() {
    return orderStore.orderForm.cargo.insurance.type
  },
  set(type: 'without' | 'cargoInsurance' | 'noDeclaredValue') {
    if (orderStore.orderForm.cargo.insurance.type != type) {
      orderStore.orderForm.cargo.insurance.type = type
      orderStore.getOrderPriceAction()
    }
  }
})

const insuranceValue = computed({
  get() {
    return orderStore.orderForm.cargo.insurance.value
  },
  set(value: number) {
    orderStore.orderForm.cargo.insurance.value = value
  }
})

const transportationId = computed({
  get() {
    return orderStore.orderForm.cargo.transportationId
  },
  set(value: string) {
    orderStore.orderForm.cargo.transportationId = value
  }
})

function onChangeInsuranceValue() {
  orderStore.getOrderPriceAction()
}

watch(() => insuranceTypes.value[1]?.disabled,
  (value) => {
    if (value && insuranceType.value === 'noDeclaredValue') {
      orderStore.orderForm.cargo.insurance.type = 'cargoInsurance'
      orderStore.orderForm.cargo.insurance.value = 1000
    }
  },
  {immediate: true}
)
</script>
